import productRoutes from "./product/routes"

import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{ path: "/", redirect: "/products" }, ...productRoutes],
})

export default router
